export const INIT = 0;
export const REQUEST = 2;
export const FINISH = 3;



// WEBPACK FOOTER //
// ./js/constants/PasswordRecoveryState.js